module.exports = __webpack_public_path__ + "img/verb.03346c90.png";